import { type CSSProperties, type ReactNode } from 'react';
import { Link } from '@insights-ltd/design-library/components';
import { CUSTOMER_EXPERIENCE_EMAIL_LINK } from 'variables';

type CustomerExperienceLinkProps = {
  id: string;
  fontSize?: CSSProperties['fontSize'];
  children?: ReactNode;
};

const CustomerExperienceLink = ({
  id,
  fontSize,
  children,
}: CustomerExperienceLinkProps) => (
  <Link
    type="link"
    sx={(theme) => ({
      cursor: 'pointer',
      userSelect: 'none',
      fontWeight: theme.typography.bodyBold.fontWeight,
      color: theme.palette.primary.main,
      fontSize: fontSize ?? theme.typography.bodySmall.fontSize,
    })}
    href={CUSTOMER_EXPERIENCE_EMAIL_LINK}
    id={id}
  >
    {children}
  </Link>
);

export default CustomerExperienceLink;
